var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-typing-animation",attrs:{"id":_vm.bubbleId}},[_c('img',{attrs:{"src":"/img/is-typing-animation.gif","alt":"is typing"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }